import React, { useEffect, useState } from "react";
import CommonTable from "../common/CommonTable";
import CommonModal from "../common/CommonModal";
import BranchForm from "../Forms/BranchForm";
import { useNavigate } from "react-router-dom";
import { useUser } from "../Commonfunction/UserContext";
import { getData } from "../Commonfunction/CommonFunction";
import { checkPermission } from "../Commonfunction/NewPermission";
import TopHeading from "../common/TopHeading";
import PermissionMessage from "../common/PermissionMessage";
import DeleteConfirmationModal from "../common/DeleteConfirmationModal";
import { TbEdit } from "react-icons/tb";
import { RiDeleteBin6Line } from "react-icons/ri";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Importing toast styles
import TaxTableForm from "../Forms/TaxTableForm";
import "../../assets/style/TaxTable.css";

export default function TaxTable() {
  const { role, setUserAccess } = useUser();
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [tableData, setTableData] = useState([]);
  const [rowId, setRowId] = useState(null);
  const [permissionsData, setPermissionsData] = useState();
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [permissionMassage, setPermissionMassage] = useState(false);
  const userType = localStorage.getItem("user_type");
  const [customerStatusUrl, setCustomerStatusUrl] =
    useState("/api/all-counties");
  const handleClose = () => {
    setShowModal(false);
    setRowId(null);
    fetchData();
  };

  // Define columns with action column correctly structured
  const columns = [
    {
      key: "action",
      label: "Action",
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", width: "100%" }}>
          <div
            className="action-buttons"
            style={{ display: "flex", gap: "10px" }}
          >
            <button
              className="edit-btn"
              onClick={() => {
                fetchDataUserAccess("edit", true, params, "");
              }}
            >
              <TbEdit size={18} />
            </button>
            <button
              className="delete-btn"
              onClick={() => fetchDataUserAccess("delete", true, params, "")}
            >
              <RiDeleteBin6Line size={18} />
            </button>
          </div>
        </div>
      ),
    },
    { key: "county_name", label: "County (County Code)", sortable: true },
    { key: "city_name", label: "City", sortable: true },
    { key: "state_name", label: "State", sortable: true },
    { key: "zip_code", label: "Zipcode", sortable: true },
    { key: "rate", label: "Rate", sortable: true },

   
  ];
  const fetchDataUserAccess = async (method, showPopup, params, goToLink) => {
    try {
      const result = await getData("/api/user-access");
      if (result.success) {
        setUserAccess(result);
        checkPermission(role, method, result.permission)
          ? showPopup
            ? method == "delete"
              ? (setOpen(true), setRowId(params.id))
              : params
              ? (setRowId(params.id), setShowModal(true))
              : (setRowId(null), setShowModal(true))
            : goToLink
            ? navigate(goToLink)
            : ""
          : setPermissionMassage(true);
      }
    } catch (error) {
      console.log("Error:123213", error);
    }
  };
  const fetchData = async () => {
    setTableData([]);
    try {
      const result = await getData(customerStatusUrl);
      if (result.success) {
        setPermissionsData(result?.permission);
        if (!checkPermission("County", "view", result.permission)) {
          setPermissionMassage(true);
          setTimeout(() => {
            navigate("/dashboard");
          }, 2000);
        }
        setTableData(result?.data);
      } else {
        setPermissionsData(result?.permission);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const handleDeleteClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    fetchData();
  }, [customerStatusUrl]);

  const indexedRows =
    tableData.length > 0 &&
    tableData.map((data, index) => ({
      index: index + 1,
      id: data.id,
      county_name: data.county_name + " (" + data.code + ")",
      city_name: data.city_name,
      state_name: data.state_name,
      // code: data.code,
      rate: data.rate,
      zip_code: data.zip_code,

      // high: data.high_value,
      // low: data.low_value,
    }));

  return (
    <div className="usa-prose">
      <TopHeading
        // heading="Tax Table"
        setShowModal={() => {
          fetchDataUserAccess("add", true, "", "");
        }}
        isHideBtn={true}
      />
      <div className="tf-container">
        <div className="tf-wrapper">
          <div className="tf-title-area">
            <span className="tf-title">Filter Taxes</span>
            <div className="tf-buttons">
              <div
                className={`tf-button ${
                  customerStatusUrl === "/api/all-counties" ? "active" : ""
                }`}
                onClick={() => setCustomerStatusUrl("/api/all-counties")}
              >
                <span className="tf-button-text">ALL TAXES</span>
                <svg
                  className="tf-button-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 12H16M12 8V16"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <div
                className={`tf-button ${
                  customerStatusUrl === "/api/all-counties/deleted"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  setCustomerStatusUrl("/api/all-counties/deleted")
                }
              >
                <span className="tf-button-text">Deleted</span>
                <svg
                  className="tf-button-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 6L6 18M6 6L18 18"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <div
                className={`tf-button ${
                  customerStatusUrl === "/api/all-counties/updated"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  setCustomerStatusUrl("/api/all-counties/updated")
                }
              >
                <span className="tf-button-text">Updated</span>
                <svg
                  className="tf-button-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 6L9 17L4 12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <div
                className={`tf-button ${
                  customerStatusUrl === "/api/all-counties/applicable"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  setCustomerStatusUrl("/api/all-counties/applicable")
                }
              >
                <span className="tf-button-text">Applicable</span>
                <svg
                  className="tf-button-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <path
                    d="M8 12L11 15L16 9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CommonTable columns={columns} data={indexedRows || []} />
      {open && (
        <DeleteConfirmationModal
          open={true}
          handleClose={() => setOpen(false)}
          request_url={`/api/delete-county/${rowId}`}
          getApi={fetchData}
        />
      )}
      {showModal && (
        <CommonModal
          isOpen={showModal}
          onClose={handleClose}
          title={rowId ? "Edit Tax Table" : "Add Tax Table"}
        >
          <TaxTableForm
            onClose={handleClose}
            id={rowId}
            fetchData={fetchData}
          />
        </CommonModal>
      )}
      {permissionMassage && (
        <PermissionMessage
          open={true}
          handleClose={() => {
            setPermissionMassage(false);
          }}
        />
      )}
    </div>
  );
}
